import styled from 'styled-components';

export const Wrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
`;
